<template>
  <div>
    <div class="config-title">
      <h2 class="text-dark text-thin">
        Listagem de Times Aduaneiros
      </h2>

      <div>
        <button @click.prevent="openCreate" class="crm-button">
          <div class="flex ai-c fgap1">
            <plus-icon :size="20" color="currentColor"/>
            Adicionar
          </div>
        </button>
      </div>
    </div>

    <hr class="mb-4"/>

    <config-table
      :table-config="tableConfig"
      :tableData="customsTeams"
      :columns="tableColumns"
      empty-message="Nenhum time aduaneiro cadastrado."
    >
      <template #createdAt="{ item }">
        <span>{{ formatDateTime(item.createdAt) }}</span>
      </template>
      <template #actions="{ item }">
        <div class="actions-table">
          <a class="edit-button" href="#" @click.prevent="openEdit(item)">
            <config-edit-icon :size="16"/>
          </a>
          <a class="remove-button" href="#" @click.prevent="destroyCustomsTeam(item.id)">
            <config-trash-icon :size="16"/>
          </a>
        </div>
      </template>
    </config-table>

    <v-modal
      :title="`${modalData.id ? 'Atualizar Time Aduaneiro' : 'Adicionar Time Aduaneiro'}`"
      description=""
      :width="900"
      :height="0"
      :handler="storeModal"
      @requestClose="closeStoreModal"
    >
      <template #content>
        <form @submit.prevent class="config-user-form">
          <div class="span-12">
            <h4 class="text-dark">Dados do Time Aduaneiro</h4>
          </div>

          <div class="span-4">
            <v-input
              type="text"
              name="code"
              label="Código"
              v-model="modalData.code"
              :class="{'input-danger': getError('code') }"
            ></v-input>
            <div class="field-error" v-if="getError('code')">
              {{ getError('code') }}
            </div>
          </div>

          <div class="span-8">
            <v-input
              type="text"
              name="name"
              label="Nome"
              v-model="modalData.name"
              :class="{'input-danger': getError('name') }"
            ></v-input>
            <div class="field-error" v-if="getError('name')">
              {{ getError('name') }}
            </div>
          </div>

          <div class="span-12">
            <v-input
              type="email"
              name="email"
              label="E-mail"
              v-model="modalData.email"
              :class="{'input-danger': getError('email') }"
            ></v-input>
            <div class="field-error" v-if="getError('email')">
              {{ getError('email') }}
            </div>
          </div>
        </form>

        <div class="columns md-gap mt-4">
          <div class="span-12">
            <div class="card">
              <div class="card-content p-4">
                <div class="columns md-gap">
                  <div class="span-8">
                    <h4 class="tx-inverse mg-b-2 tx-semibold tx-uppercase tx-18">
                      Usuários operacionais vinculados
                    </h4>
                    <p class="mg-b-3">
                      Vincule ou remova usuários operacionais a este time aduaneiro.
                    </p>
                  </div>

                  <div class="span-8">
                    <div class="row">
                      <div class="col-6">
                        <div class="documents-container">
                          <div class="documents-header">USUÁRIOS DISPONÍVEIS</div>
                          <div class="documents-search">
                            <i class="fa fa-search"></i>
                            <input type="text" v-model="userSearch" />
                          </div>
                          <ul class="documents-list">
                            <li
                              v-for="user in filteredAvailableUsers"
                              :key="'u-avail-' + user.id"
                              @click.prevent="linkUser(user.id)"
                            >
                              <span class="tx-uppercase">
                                <span class="tx-semibold">{{ user.name }}</span>
                              </span>
                              <a href="#" @click.prevent class="documents-button small">
                                <i class="fa fa-angle-double-right"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="col-6">
                        <div class="documents-container">
                          <div class="documents-header">USUÁRIOS VINCULADOS</div>
                          <div class="documents-search">
                            <p>{{ linkedUsers.length }} usuário(s) vinculado(s)</p>
                          </div>
                          <ul class="documents-list">
                            <li
                              v-for="user in linkedUsers"
                              :key="'u-link-' + user.id"
                              @click.prevent="unlinkUser(user.id)"
                            >
                              <span class="tx-uppercase">
                                <span class="tx-normal">{{ user.name }}</span>
                              </span>
                              <a href="#" @click.prevent class="documents-button small">
                                <i class="fa fa-angle-double-left"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="flex ai-c jc-c fgap2">
          <button class="crm-button red" @click.prevent="closeStoreModal">Cancelar</button>
          <button class="crm-button" v-if="modalData.id" @click.prevent="updateCustomsTeam">Salvar</button>
          <button class="crm-button" v-else @click.prevent="storeCustomsTeam">Adicionar</button>
        </div>
      </template>
    </v-modal>
  </div>
</template>

<script>
import PlusIcon from '@/components/crm/Icons/Plus.vue';
import ConfigTable from '@/components/Configuration/ConfigTable.vue';
import Axios from 'axios';
import config from '@/config';
import ConfigEditIcon from '@/components/Configuration/icons/ConfigEditIcon.vue';
import ConfigTrashIcon from '@/components/Configuration/icons/ConfigTrashIson.vue';
import VModal from '@/components/VModal.vue';
import VInput from '@/components/VInput.vue';
import Swal from 'sweetalert2';
import * as yup from 'yup';

const nullToEmptyString = (value) => (value == null ? '' : value);

const customsTeamSchema = yup.object().shape({
  name: yup.string().transform(nullToEmptyString).required('Campo obrigatório').min(3, 'Mínimo de 3 caracteres').max(120, 'Máximo de 120 caracteres')
    .typeError('Campo inválido'),
  code: yup.string().transform(nullToEmptyString).required('Campo obrigatório').min(1, 'Campo obrigatório').max(100, 'Máximo de 100 caracteres')
    .typeError('Campo inválido'),
  email: yup.string().transform(nullToEmptyString).test(
    'email',
    'E-mail inválido',
    (value) => !value || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
  ),
});

export default {
  name: 'ConfigCustomsTeamTab',
  components: {
    VInput, VModal, ConfigTrashIcon, ConfigEditIcon, ConfigTable, PlusIcon,
  },
  data() {
    return {
      customsTeams: [],
      users: [],
      linkedTeamIds: [],
      linkedUserIds: [],
      userSearch: '',
      modalData: {
        id: null,
        name: '',
        code: '',
        email: '',
      },
      formErrors: [],
      storeModal: false,
      tableConfig: {
        perPage: 10,
        useSearch: true,
        centeredCell: false,
        showRecords: true,
        showPerPage: true,
      },
      tableColumns: [
        {
          label: 'Nome',
          field: 'name',
        },
        {
          label: 'Código',
          field: 'code',
        },
        {
          label: 'E-mail',
          field: 'email',
        },
        {
          label: 'Criado em',
          field: 'createdAt',
        },
        {
          class: 'text-center flex ai-c jc-c',
          label: 'Ações',
          field: 'actions',
        },
      ],
    };
  },
  computed: {
    linkedUsers() {
      const idSet = new Set(this.linkedUserIds);
      return this.users.filter((u) => idSet.has(u.id));
    },
    availableUsers() {
      const idSet = new Set(this.linkedUserIds);
      return this.users.filter((u) => !idSet.has(u.id));
    },
    filteredAvailableUsers() {
      const list = this.availableUsers;
      if (!this.userSearch || this.userSearch.length === 0) {
        return list;
      }
      const regex = new RegExp(this.userSearch, 'gi');
      return list.filter((user) => regex.test(user.name || ''));
    },
  },
  methods: {
    formatDateTime(value) {
      if (value == null || value === '') {
        return '—';
      }
      try {
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) {
          return String(value);
        }
        return d.toLocaleString('pt-BR');
      } catch (e) {
        return String(value);
      }
    },
    getError(path) {
      const err = this.formErrors.find((e) => e.path === path);
      return err ? err.message : '';
    },
    buildPayload() {
      const emailTrimmed = (this.modalData.email || '').trim();
      return {
        name: this.modalData.name,
        code: this.modalData.code,
        email: emailTrimmed.length ? emailTrimmed : null,
        teamIds: this.linkedTeamIds.slice(),
        userIds: this.linkedUserIds.slice(),
      };
    },
    linkUser(userId) {
      if (this.linkedUserIds.indexOf(userId) === -1) {
        this.linkedUserIds.push(userId);
      }
    },
    unlinkUser(userId) {
      this.linkedUserIds = this.linkedUserIds.filter((id) => id !== userId);
    },
    async getCustomsTeams() {
      this.$store.commit('setLoading', {
        show: true,
        label: 'Carregando...',
        description: 'Recuperando listagem de times aduaneiros.',
      });
      try {
        const response = await Axios.get(`${config.env.API_DEFAULT.host}/customs-teams`);
        const data = response.data && response.data.data;
        this.customsTeams = Array.isArray(data) ? data : [];
      } catch (e) {
        Swal.fire({
          title: 'Times Aduaneiros',
          text: 'Erro ao listar times aduaneiros!',
          type: 'error',
        });
      } finally {
        this.$store.commit('setLoading', {
          show: false,
        });
      }
    },
    async getUsers() {
		this.$store.commit('setLoading', {
			show: true,
			label: 'Carregando...',
			description: 'Recuperando listagem de usuários operacionais.',
		});
		try {
			const response = await Axios.get(
				`${config.env.API_DEFAULT.host}/users/get-operational-users-with-team`,
			);
			this.users = Array.isArray(response.data) ? response.data : [];
		} catch (e) {
			this.users = [];
			Swal.fire({
				title: 'Times Aduaneiros',
				text: 'Erro ao listar usuários operacionais!',
				type: 'error',
			});
		} finally {
			this.$store.commit('setLoading', {
				show: false,
			});
		}
    },
    openCreate() {
      this.formErrors = [];
      this.userSearch = '';
      this.linkedTeamIds = [];
      this.linkedUserIds = [];
      this.modalData = {
        id: null,
        name: '',
        code: '',
        email: '',
      };
      this.storeModal = true;
    },
    async openEdit(item) {
      this.formErrors = [];
      this.userSearch = '';
      this.storeModal = true;
      this.$store.commit('setLoading', {
        show: true,
        label: 'Carregando...',
        description: 'Carregando dados do time aduaneiro.',
      });
      try {
        const response = await Axios.get(`${config.env.API_DEFAULT.host}/customs-teams/${item.id}`);
        const entity = response.data && response.data.data;
        if (!entity) {
          Swal.fire({
            title: 'Times Aduaneiros',
            text: 'Time aduaneiro não encontrado.',
            type: 'error',
          });
          this.storeModal = false;
          return;
        }
        this.modalData = {
          id: entity.id,
          name: entity.name ?? '',
          code: entity.code ?? '',
          email: entity.email ?? '',
        };
        const teams = entity.teams || [];
        this.linkedTeamIds = teams.map((t) => t.id).filter((id) => id != null);
        const usersList = entity.users || [];
        this.linkedUserIds = usersList.map((u) => u.id).filter((id) => id != null);
      } catch (e) {
        Swal.fire({
          title: 'Times Aduaneiros',
          text: 'Não foi possível carregar o time aduaneiro.',
          type: 'error',
        });
        this.storeModal = false;
      } finally {
        this.$store.commit('setLoading', {
          show: false,
        });
      }
    },
    closeStoreModal() {
      this.formErrors = [];
      this.userSearch = '';
      this.linkedTeamIds = [];
      this.linkedUserIds = [];
      this.storeModal = false;
      this.modalData = {
        id: null,
        name: '',
        code: '',
        email: '',
      };
    },
    async storeCustomsTeam() {
      this.formErrors = [];
      this.$store.commit('setLoading', {
        show: true,
        label: 'Carregando...',
        description: 'Cadastrando time aduaneiro.',
      });
      try {
        await customsTeamSchema.validate(this.modalData, {
          abortEarly: false,
        });
        await Axios.post(
          `${config.env.API_DEFAULT.host}/customs-teams`,
          this.buildPayload(),
        );
        Swal.fire({
          title: 'Times Aduaneiros',
          text: 'Time aduaneiro cadastrado com sucesso!',
          type: 'success',
        });
        await this.getCustomsTeams();
        this.closeStoreModal();
      } catch (e) {
        if (e.name === 'ValidationError') {
          this.formErrors = e.inner;
        } else {
          Swal.fire({
            title: 'Times Aduaneiros',
            text: e.response.data?.data || 'Erro ao cadastrar time aduaneiro!',
            type: 'error',
          });
        }
      } finally {
        this.$store.commit('setLoading', {
          show: false,
        });
      }
    },
    async updateCustomsTeam() {
      this.formErrors = [];
      this.$store.commit('setLoading', {
        show: true,
        label: 'Carregando...',
        description: 'Atualizando time aduaneiro.',
      });
      try {
        await customsTeamSchema.validate(this.modalData, {
          abortEarly: false,
        });
        await Axios.put(
          `${config.env.API_DEFAULT.host}/customs-teams/${this.modalData.id}`,
          this.buildPayload(),
        );
        Swal.fire({
          title: 'Times Aduaneiros',
          text: 'Time aduaneiro atualizado com sucesso!',
          type: 'success',
        });
        await this.getCustomsTeams();
        this.closeStoreModal();
      } catch (e) {
        if (e.name === 'ValidationError') {
          this.formErrors = e.inner;
        } else {
          Swal.fire({
            title: 'Times Aduaneiros',
            text: 'Erro ao atualizar time aduaneiro!',
            type: 'error',
          });
        }
      } finally {
        this.$store.commit('setLoading', {
          show: false,
        });
      }
    },
    async destroyCustomsTeam(id) {
      try {
        const confirm = await this.$swal({
          title: 'Você tem certeza?',
          text: 'Se você excluir o time aduaneiro, não será possível recuperá-lo para uso posterior.',
          icon: 'warning',
          buttons: ['Não', 'Sim'],
          dangerMode: true,
        });
        if (confirm) {
          this.$store.commit('setLoading', {
            show: true,
            label: 'Carregando...',
            description: 'Removendo time aduaneiro.',
          });
          await Axios.delete(`${config.env.API_DEFAULT.host}/customs-teams/${id}`);
          Swal.fire({
            title: 'Times Aduaneiros',
            text: 'Time aduaneiro removido com sucesso!',
            type: 'success',
          });
          await this.getCustomsTeams();
        }
      } catch (e) {
        Swal.fire({
          title: 'Times Aduaneiros',
          text: 'Erro ao remover time aduaneiro!',
          type: 'error',
        });
      } finally {
        this.$store.commit('setLoading', {
          show: false,
        });
      }
    },
  },
  async mounted() {
	await this.getCustomsTeams();
    await this.getUsers();
  },
};
</script>

<style scoped>

.config-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.config-user-form {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1rem;
  align-content: start;
}

.config-user-form .span-4 {
  grid-column: span 4;
}

.config-user-form .span-8 {
  grid-column: span 8;
}

.config-user-form .span-12 {
  grid-column: span 12;
}

.documents-container {
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e2e2e2;
  height: 300px;
  padding: 15px 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.documents-header {
  text-align: center;
  font-size: 1rem;
  font-weight: bold;
  color: black;
  margin-bottom: 10px;
}

.documents-search {
  margin-bottom: 10px;
  text-align: center;
  position: relative;
}

.documents-search input {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e2e2e2;
  padding-left: 45px;
}

.documents-search input:focus {
  background-color: white;
}

.documents-search i {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.documents-list {
  padding: 0;
  list-style: none;
  margin: 0;
  overflow: auto;
  height: 100%;
}

.documents-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 5px;
  transition: all 0.2s ease-in-out 0s;
  cursor: pointer;
  border-radius: 8px;
  position: relative;
  word-break: break-all;
  gap: 10px;
}

.documents-list li a {
  opacity: 0;
  transition: all 0.2s ease-in-out 0s;
}

.documents-list li:hover {
  background-color: #d2d2d2;
  color: black;
}

.documents-list li:hover a {
  opacity: 1;
}

.documents-list li:not(:last-of-type) {
  margin-bottom: 6px;
}

.documents-list li:not(:last-of-type)::after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background-color: #e2e2e2;
  position: absolute;
  top: calc(100% + 3px);
  left: 0;
  right: 0;
}

.documents-button {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  color: white;
  border-radius: 45px;
  font-size: 24px;
  cursor: pointer;
}

.documents-button.small {
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  font-size: 12px;
}
</style>
